import { RISK_ERRORS_LIST_URL } from '@/constants';
import { UnauthorizedError, UnexpectedError } from '@/services';
import { RiskErrorModel } from '@/types';
import { HttpStatusCode, fromRiskBff, httpClient } from '@/utils';
import { RiskErrorsResult } from './types';

export const ALTERNATIVE_ERROR_MESSAGE =
  'Há pendências na Gerenciadora de Risco. Para obter mais informações, entre em contato com a Skymark pelo telefone (11) 3651-7377.';

export const loadRiskErrorsService = async (id: string): Promise<RiskErrorModel> => {
  const uri = fromRiskBff(RISK_ERRORS_LIST_URL).replace(':uuid', id);
  const { body, status } = await httpClient.get<RiskErrorsResult>(uri);

  const handleResult = (): RiskErrorModel => {
    if (body?.data?.errors?.length === 1) {
      const [error] = body.data.errors;
      const message = error.toLowerCase() === 'informações adicionais' ? ALTERNATIVE_ERROR_MESSAGE : error;
      return { ...body.data, errors: [message] };
    }

    return body.data;
  };

  switch (status) {
    case HttpStatusCode.ok:
      return handleResult();

    case HttpStatusCode.unauthorized:
      throw new UnauthorizedError();

    default:
      throw new UnexpectedError();
  }
};
